"use client";

import LoginComponent from "./LoginComponent";

interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
  isRegistration?: boolean;
  isCheckoutFlow?: boolean;
  onCheckoutReady?: () => void;
}

export default function LoginModal({
  isOpen,
  onClose,
  isRegistration,
  isCheckoutFlow,
  onCheckoutReady,
}: LoginModalProps) {
  if (!isOpen) return null;
  return (
    <div
      className=" font-heading fixed inset-0 z-[1000] flex items-center justify-center px-4 bg-black bg-opacity-40"
      style={{ margin: "0px" }}
    >
      <LoginComponent onClose={onClose} registration={isRegistration} isCheckoutFlow={isCheckoutFlow} onCheckoutReady={onCheckoutReady} />
    </div>
  );
}
